import { Pipe, PipeTransform } from '@angular/core';
import { aggregateBy, AggregateResult, AggregateDescriptor } from '@progress/kendo-data-query';
import { TranslateService } from '@ngx-translate/core';
import { GridDataResult } from '@progress/kendo-angular-grid';

@Pipe({
  name: 'gridAggregate',
  standalone: true
})
export class GridAggregatePipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: any, gridData: any[] | GridDataResult | null | undefined, aggregates: AggregateDescriptor[]): string { //Array<any>

    var gd = gridData as GridDataResult;
    var data = gd?.data;

    var property = String(value);

    var lang = this.translate.getBrowserCultureLang();

    if (gd != undefined && data && data.length > 0) {
      var agg = aggregates.filter(a => a.field == property)[0];
      const dataItem: IAggregateResult = this.aggregate(data, agg);

      if (dataItem) {
        if (dataItem.count != undefined) {
          return dataItem.count.toLocaleString(lang, { maximumFractionDigits: 2 });
        } else if (dataItem.average != undefined) {
          return dataItem.average.toLocaleString(lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
        } else if (dataItem.sum != undefined) {
          return dataItem.sum.toLocaleString(lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
        } else if (dataItem.min != undefined) {
          return dataItem.min.toLocaleString(lang, { maximumFractionDigits: 2 });
        } else if (dataItem.max != undefined) {
          return dataItem.max.toLocaleString(lang, { maximumFractionDigits: 2 });
        }
      }
    }

    return "";
  }

  aggregate(data: any[], agg: AggregateDescriptor): IAggregateResult {

    const result: IAggregateResult = {};

    if (data != undefined && data.length > 0 && agg != undefined) {
      var values: number[] = data.filter(d => d[agg.field] != null).map(r => r[agg.field]);
      if (agg.aggregate == "average") {
        result.average = this.average(values);
      } else if (agg.aggregate == "sum") {
        result.sum = this.sum(values);
      } else if (agg.aggregate == "count") {
        result.count = values.length;
      } else if (agg.aggregate == "min") {
        result.min = Math.min(...values);
      } else if (agg.aggregate == "max") {
        result.max = Math.max(...values);
      }
    }

    return result;
  }

  average = (array: any[]) => array.reduce((a, b) => a + b) / array.length;
  sum = (array: any[]) => array.reduce((a, b) => a + b);

}

export class IAggregateResult {
  count?: number;
  average?: number;
  sum?: number;
  min?: number;
  max?: number;
}
